<script>
  export default {
    name: 'Account',

    components: {
      ProfileUser: () => import('./user-profile.vue'),
      History: () => import('@/views/app/dashboard/history/views/index.vue'),
      //Kyc: () => import('@/views/app/dashboard/KYC.vue'),
      ResponsibleGaming: () => import('@/views/app/dashboard/account/views/responsible-gaming.vue'),
      RsgTools: () => import('@/views/app/dashboard/account/views/rsg-tools.vue'),
    },

    data: () => ({
      selectedTab: 'ProfileUser',

      tabs: [
        {
          text: 'Your Profile',
          value: 'ProfileUser',
          to: '/profileuser/yourprofile',
        },
        {
          text: 'History',
          value: 'History',
          to: '/profileuser/history',
        },
        // {
        //   text: 'KYC',
        //   value: 'kyc',
        //   to: '/profileuser/kyc',
        // },
        {
          text: 'RSG Tools',
          value: 'rsg-tools',
          to: '/profileuser/rsg-tools',
        },
      ],
    }),

    watch: {
      selectedTab(newTab) {
        if (!newTab) return;
        const newPath = this.tabs.find((tab) => tab.value === newTab)?.to;
        if (!newPath || this.$route.path === newPath) return;
        this.$router.replace({ path: newPath });
      },
      '$route.path': {
        handler(newPath) {
          const newTab = this.tabs.find((tab) => tab.to === newPath)?.value;
          if (!newTab) return;
          this.selectedTab = newTab;
        },
        immediate: true,
      },
    },
  };
</script>

<template>
  <div class="dashboard-bg pvp-lg h-100 profile-history">
    <v-row class="text-center pb-md-4 pt-1" style="margin-inline: 0 !important">
      <v-toolbar class="dashboard-toolbar" elevation="8">
        <v-tabs v-model="selectedTab" :fixed-tabs="$vuetify.breakpoint.smAndDown" icons-and-text>
          <v-tabs-slider color="transparent" />
          <v-tab
            v-for="(tab, index) in tabs"
            :key="index"
            :tab-value="tab.value"
            class="text-subtitle-2 text-md-h6 bold"
            exact
          >
            <div class="tabTitle">
              {{ tab.text }}
            </div>
          </v-tab>
        </v-tabs>
      </v-toolbar>
    </v-row>

    <v-tabs-items v-model="selectedTab">
      <v-tab-item v-for="(tab, index) in tabs" :key="index" :value="tab.value">
        <component :is="tab.value" v-show="selectedTab === tab.value" :key="tab.value" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<style lang="scss" scoped>
  .profile-history {
    @media screen and (min-width: 1281px) {
      width: 100%;
      max-width: calc(100vw - 389px - 64px);
      margin-inline: auto;
    }

    @media screen and (min-width: 1842px) {
      max-width: 1448px;
      padding-right: 32px;
    }
  }

  .tabTitle {
    position: relative;
    z-index: 2 !important;

    @media screen and (min-width: 960px) {
      font-size: 18px !important;
      margin-bottom: 0 !important;
    }
  }

  .v-tabs-items {
    background: transparent !important;
    height: 100%;

    &::v-deep {
      .v-window-item--active {
        height: 100%;
      }
    }
  }
</style>
